import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import { MaterializeAction, MaterializeDirective, toast } from 'angular2-materialize';
import { ActivatedRoute, Router } from '@angular/router';
import { Utils } from '../../util';
import { Subscription } from 'rxjs';

import { PurchaseRequestService, ProductsInRequest } from '../../services/purchase-request.service';
import { CatalogsSettingsService } from '../../services/catalogs-settings.service';
import { ProductCmpaService } from '../../services/product-cmpa.service';
import { AuthService } from '../../services/auth.service';
import { UserService } from '../../services/user.service';
import { ProductionOrderService } from '../../services/production-order.service';
import { CustomerSupplierService, CustomerSupplierId } from '../../services/customer-supplier.service';
import { UnitService, UnitId } from '../../services/unit.service';
import { WarehouseService, Warehouse } from '../../services/warehouse.service';

@Component({
  selector: 'app-update-purchase-request',
  templateUrl: './update-purchase-request.component.html',
  styleUrls: ['./update-purchase-request.component.css']
})
export class UpdatePurchaseRequestComponent implements OnInit, OnDestroy {
  updateControl: boolean = true;

  id: string;

  loggedUserId: string;
  loggedUserName: string;
  date: string;
  folio: number;

  prCmpas = {};
  prCmpasInit: any;
  prCmpaError: Boolean = false;
  productsError: Boolean = false;
  onEdit: number = -1;
  productsInRequest = [];
  wares: {name: string, prs: {[prById: string]: number} }[] = [];

  purchaseRequestForm: FormGroup;
  prForRequestForm: FormGroup;

  modalActionsPrForRequest = new EventEmitter<string|MaterializeAction>();
  modalParamsPrForRequest = [{dismissible: true}];
  
  prCmpasSub: Subscription;
  prCmpaSub: Subscription;
  productionOrderSub: Subscription;
  wareSub: Subscription;
  supplierSub: Subscription;
  customerSub: Subscription;
  
  pickadateParams = Utils.pickadateParams();

  constructor(
    private purchaseRequestService: PurchaseRequestService,
    private productionOrderService: ProductionOrderService,
    private customerService: CustomerSupplierService,
    private prCmpaService: ProductCmpaService,
    private authService: AuthService,
    private userService: UserService,
    private settings: CatalogsSettingsService,
    private unitService: UnitService,
    private wareService: WarehouseService,
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {
    this.createForm();
    this.createFormPrForOrder();

    this.id = this.activatedRoute.snapshot.paramMap.get('id');
    let sub = this.purchaseRequestService.getPurchaseRequest(this.id).subscribe(([pRequest]) => {
      sub.unsubscribe();
      this.productsInRequest = pRequest.productsInRequest;
      this.getProductNames();
      this.selectedProductionOrderId = pRequest.productionOrderRef && pRequest.productionOrderRef.id || '';
      this.loggedUserId = pRequest.requesterObj.id;
      this.loggedUserName = `${pRequest.requesterObj.name} ${pRequest.requesterObj.lastName}`;
      this.purchaseRequestForm.patchValue({user: this.loggedUserName, ...pRequest});
    })

    this.productionOrders = {};
    this.customerSub = this.customerService.getCustomers().subscribe(customers => {
      this.productionOrderSub = this.productionOrderService.getProductionOrders().subscribe(productionOrders => {
        this.rowsRead[0] = productionOrders.map(({id$, ...productionOrder}) => {
          let customerName = customers.find(({id$: cId}) => productionOrder.customer.id == cId).name;
          return this.productionOrders[id$] = {id: id$,customerName, ...productionOrder}; 
        });
      });
    });

    this.supplierSub = this.customerService.getSuppliers().subscribe(suppliers => {
      this.rowsRead[1] = suppliers.map(supplier => {
        supplier.id = supplier.id$;
        this.suppliers[supplier.id] = {...supplier};
        return supplier;
      });
    });

    this.wareSub = this.wareService.getWarehouses().subscribe((wares: Warehouse[]) => {
      this.wares = wares.map(({name, products}) => {
        let prs: {[id: string]: number} = {};
        for(let pr of products) prs[pr.ref.id] = pr.quantity || 0;
        return {name, prs};
      });
    });

    //Rerive data for autocomplete | productCmpa
    let unitSub = this.unitService.getUnits().subscribe(unitArray => {
      unitSub.unsubscribe();
      let units: {[id: string]: UnitId} = unitArray.reduce((acc, cur) => ({...acc, [cur.id]: cur}), {});
      this.prCmpasSub = this.prCmpaService.getPrCmpas().subscribe(prCmpas => {      
        const data = prCmpas.reduce((acc, cur) => {
          let characs = cur.characs.reduce((acc2, cur2, index) => {
            let {symbol = ''} = units[<string>cur2.unitId.id] || {};
            return `${acc2}${index ? ', ' : ''}${cur2.name.charAt(0)} ${cur2.value}${symbol ? ` ${symbol}` : ''}`;
          }, '');
          let fullName = `${cur.name} - ${characs} - ${cur.code}`.trim();
          acc[fullName] = null;
          this.prCmpas[fullName] = cur.id;
          this.prCmpas[`Unit of: ${fullName}`] = cur.unitRef ? units[<string> cur.unitRef.id].name : '';
          return acc;
        }, {});
        this.prCmpasInit = {
          'data': data
        }
      });
    });
  }

  ngOnInit() {
  }
  ngOnDestroy() {
    this.prCmpasSub.unsubscribe();
    this.productionOrderSub.unsubscribe();
    this.supplierSub && this.supplierSub.unsubscribe();
    if(this.customerSub) this.customerSub.unsubscribe();
  }
  createForm() {
    this.purchaseRequestForm = this.fb.group({
      user: ['', Validators.required],
      date: ['', Validators.required],
      folio: ['', Validators.required],
      deliveryRequiredDate: '',
      notes: '',
    });
  }
  createFormPrForOrder() {
    this.prForRequestForm = this.fb.group({
      name: ['', Validators.required],
      quantity: ['', [Validators.required, Validators.min(1)]],
    });
  }
  getProductNames(){
    let subs: Subscription[] = [];
    this.productsInRequest.map(({productRef}, index)  => {
      subs[index] = this.prCmpaService.getPrCmpa(productRef).subscribe(([prCmpa]) => {
        this.productsInRequest[index].name = prCmpa.name;
        subs[index].unsubscribe();
      });
    });
  }

  showWaresPrId: string = '';
  onPrChange(): void {
    let prName = this.prForRequestForm.get('name').value;
    this.showWaresPrId = this.prCmpas[prName] || '';
  }
  openModalPrForRequest(index: number) {
    this.onEdit = index;
    this.showWaresPrId = '';
    this.prForRequestForm.reset();
    this.prCmpaError = false;
    if (index > -1) {
      this.prForRequestForm.get('name').setValue(this.productsInRequest[index].name);
      this.prForRequestForm.get('quantity').setValue(this.productsInRequest[index].quantity);
      this.onPrChange();
    }
    this.modalActionsPrForRequest.emit({ action: 'modal', params: ['open'] });
  }
  closeModalPrForRequest() {
    this.modalActionsPrForRequest.emit({ action: 'modal', params: ['close'] });
  }

  addPrForRequest({ value, valid }: { value: any, valid: boolean }) {
    if(this.prCmpas[value.name] == undefined){
      this.prCmpaError = true;
      this.prForRequestForm.get('name').setValue('');
    }else{
      value.productRef = this.prCmpas[value.name];
      value.unitName = this.prCmpas[`Unit of: ${value.name}`] || '';
      this.productsInRequest.push(value);
      this.closeModalPrForRequest();
    }
  }
  editPrForRequest({ value, valid }: { value: any, valid: boolean }, index: number) {
    this.productsInRequest[index].quantity = value.quantity;
    this.closeModalPrForRequest();
  }
  deletePrForRequest(index){
    this.productsInRequest.splice(index,1);
  }

  onSubmit({ value } : { value: any }){
    //if(!this.selectedProductionOrderId) return toast('Seleccione una orden de producción', 2000);
    if(this.productsInRequest.length > 0) {
      this.productsInRequest.forEach(product => {
        delete product.name;
      });
      delete value.user;
      value.supplierRef = this.selectedSupplierId ? this.customerService.getCustomerSupplierRef(this.selectedSupplierId) : null;
      value.productsInRequest = this.productsInRequest;
      value.productionOrderRef = this.selectedProductionOrderId;
      this.purchaseRequestService.updatePurchaseRequest(this.id, value);
      this.router.navigate([`/purchase_request`]);
    } else {
      this.productsError = true;
    }
  }



  //////////////////////////////////////////////////////////////////////////////////////////////READ MODAL DATA 

  modalActionsRead = new EventEmitter<string|MaterializeAction>();
  modalParamsRead = [{dismissible: true}];
  
  //ProductionOrder
  productionOrders: any = {};
  selectedProductionOrderId: string = '';
  //Supplier
  suppliers: {[id: string]: CustomerSupplierId} = {};
  selectedSupplierId: string = '';


  get readValid(){ return this.selectedProductionOrderId };

  currentReadIndex: number;
  rowsRead = [[], []];
  columnsRead = [
    [
      { title: 'Folio', name: 'name', sort: 'desc' },
      { title: 'Cliente', name: 'customerName' },
      { title: 'Compromiso de entrega', name: 'deliveryDate' },
      { title: 'Cantidad', name: 'quantity' },
      { title: 'Estatus', name: 'status' }
    ],
    [//supplier
      { title: 'Nombre', name: 'name', sort: 'asc' },
      { title: 'Descripción', name: 'description' },
      { title: 'Correo electrónico', name: 'email' }
    ],
  ]

  openModalRead(index: number) {
    this.currentReadIndex = index;
    this.data = this.rowsRead[index];
    
    this.config = this.configs[index];
  
    this.onChangeTable(this.config);
    this.modalActionsRead.emit({ action: 'modal', params: ['open'] });
  }
  closeModalRead() {
    this.modalActionsRead.emit({ action: 'modal', params: ['close'] });
  }
  selectRead({row}): any{
    if(this.currentReadIndex == 0) this.selectedProductionOrderId = row.id;
    if(this.currentReadIndex == 1) this.selectedSupplierId = row.id;
    this.closeModalRead();
  }


  data:Array<any>;
  rows:Array<any> = [];
  page:number = 1;
  itemsPerPage:number = 5;
  maxSize:number = 5;
  numPages:number = 1;
  length:number = 0;

  config;
  configs:any = this.columnsRead.map(columns => ({
    paging: true,
    sorting: {columns},
    filtering: {filterString: ''}
  }));

  /*********** Filter, sort, and pagination */

	changePage(page:any, data:Array<any> = this.data):Array<any> {
    let start = (page.page - 1) * page.itemsPerPage;
    let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;
    return data.slice(start, end);
  }

  changeSort(data:any, config:any):any {
    if (!config.sorting) {
      return data;
    }

    let columns = this.config.sorting.columns || [];
    let columnName:string;
    let sort:string;

    for (let i = 0; i < columns.length; i++) {
      if (columns[i].sort !== undefined && columns[i].sort !== '' && columns[i].sort !== false) {
        columnName = columns[i].name;
        sort = columns[i].sort;
      }
    }

    if (!columnName) {
      return data;
    }

    // simple sorting
    return data.sort((previous:any, current:any) => {
      if (previous[columnName] > current[columnName]) {
        return sort === 'desc' ? -1 : 1;
      } else if (previous[columnName] < current[columnName]) {
        return sort === 'asc' ? -1 : 1;
      }
      return 0;
    });
  }

  changeFilter(data:any, config:any):any {
    let filteredData:Array<any> = data;
    this.columnsRead[this.currentReadIndex].forEach((column:any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item:any) => {
          return item[column.name].match(column.filtering.filterString);
        });
      }
    });

    if (!config.filtering) {
      return filteredData;
    }

    if (config.filtering.columnName) {
      return filteredData.filter((item:any) => item[config.filtering.columnName].match(this.config.filtering.filterString));
    }

    let tempArray:Array<any> = [];
    filteredData.forEach((item:any) => {
      let flag = false;
      this.columnsRead[this.currentReadIndex].forEach((column:any) => {
        if (item[column.name] && item[column.name].toString().toLowerCase().match(this.config.filtering.filterString.toLowerCase())) {
          flag = true;
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }

  onChangeTable(config:any, page:any = {page: this.page, itemsPerPage: this.itemsPerPage}):any {
    if (config.filtering) {
      Object.assign(this.config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.config.sorting, config.sorting);
    }

    let filteredData = this.changeFilter(this.data, this.config);
    let sortedData = this.changeSort(filteredData, this.config);
    this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
    this.length = sortedData.length;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////READ MODAL DATA

}
